import React from "react";
import Routes from "./Routes/index";
import "../src/common/i18n/i18n";

//import Custom Style scss
import "./assets/scss/themes.scss";
function App() {
  return (
    <React.Fragment>
      <Routes />
    </React.Fragment>
  );
}

export default App;
